var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider"},[_c('div',{staticClass:"text text-center"},[_c('a',{attrs:{"href":"tel:5415880519"}},[_vm._v(" (541) 588-0519 ")])])])
}]

export { render, staticRenderFns }